import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getIn } from 'formik';
import { InputFeedback, Input, InputGroup } from '@components/common';
import API from '@utils/api';

const DEFAULT_ERROR_MSG = 'Coupon is not valid';

// Todo: error status
function CouponField(props) {
  const [validating, setIsValidating] = useState(false);
  const [serverError, setServerError] = useState(false);
  const {
    field,
    label,
    form,
    renderAddon,
    costPayload,
    onCostUpdate,
    isRecurring,
    ...rest
  } = props;
  const { name, value } = field;
  const formError = getIn(form.errors, name);
  const touched = getIn(form.touched, name);

  const { coupon: couponValue } = value || {};

  const validate = async () => {
    setIsValidating(true);
    setServerError('');
    try {
      // await API.validateCoupon(couponValue);
      let newCost;
      if (isRecurring) {
        const { result } = await API.getRecurringCostCalculations({
          ...costPayload,
          coupon: couponValue ? couponValue : undefined
        });
        newCost = result;
      } else {
        const { result } = await API.getCostCalculations({
          ...costPayload,
          coupon: couponValue ? couponValue : undefined
        });
        newCost = result;
      }

      form.setFieldTouched(name);
      form.setFieldValue(name, {
        coupon: couponValue,
        isCouponValid: true
      });
      if (onCostUpdate) {
        onCostUpdate(newCost);
      }
    } catch (err) {
      const { data } = err.response || {};
      const { error } = data || {};
      const { message } = error || {};

      if (message) {
        form.setFieldTouched(name);
        form.setFieldValue(name, {
          coupon: couponValue,
          isCouponValid: false
        });
        setServerError(message);
      } else {
        form.setFieldTouched(name);
        form.setFieldValue(name, {
          coupon: couponValue,
          isCouponValid: false
        });
        setServerError(DEFAULT_ERROR_MSG);
      }
    }

    setIsValidating(false);
  };

  const handleKeyPress = e => {
    if (e.charCode === 13) {
      e.preventDefault();
      e.stopPropagation();

      validate();
    }
  };

  const handleChange = e => {
    form.setFieldValue(name, {
      coupon: e.target.value,
      isCouponValid: true
    });
  };

  const handleBlur = async () => {
    // form.setFieldTouched(name);
    form.setFieldValue(name, {
      coupon: couponValue,
      isCouponValid: false
    });
    validate(couponValue);
  };

  const hasError = !!(touched && formError);

  const errorMsg = serverError || DEFAULT_ERROR_MSG;

  return (
    <InputGroup>
      <Input
        placeholder={label}
        error={hasError}
        value={couponValue}
        disabled={form.isSubmitting || validating}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyPress={handleKeyPress}
        {...rest}
      />
      {renderAddon && renderAddon()}
      {validating && <InputFeedback color="gray">Checking...</InputFeedback>}
      {!validating && hasError && <InputFeedback>{errorMsg}</InputFeedback>}
    </InputGroup>
  );
}

CouponField.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  label: PropTypes.string,
  renderAddon: PropTypes.func,
  costPayload: PropTypes.any,
  onCostUpdate: PropTypes.func,
  isRecurring: PropTypes.bool
};

export default CouponField;
